// Based on: https://github.com/cpulvermacher/time-travel/blob/master/src/scripts/replace_date.ts
// Store original constructors globally to prevent re-initialization issues
let OriginalDate;
let OriginalIntlDateTimeFormat;
let isInitialized = false;
export const timeTravel = (serverTime) => {
    const FAKE_DATE_STORAGE_KEY = 'timeTravelDate';
    const TICK_START_STORAGE_KEY = 'timeTravelTickStartTimestamp';
    window.sessionStorage.setItem(FAKE_DATE_STORAGE_KEY, serverTime);
    // Only initialize once to prevent re-override issues
    if (!isInitialized) {
        OriginalDate = window.Date;
        OriginalIntlDateTimeFormat = window.Intl.DateTimeFormat;
        isInitialized = true;
        // Helper to get values from sessionStorage
        function getFromStorage(key) {
            try {
                return window.sessionStorage.getItem(key);
            }
            catch (err) {
                return null;
            }
        }
        // Helper to get the timestamp when ticking started
        function getTickStartTimestamp() {
            const startTimestamp = getFromStorage(TICK_START_STORAGE_KEY);
            return startTimestamp ? Number.parseInt(startTimestamp, 10) : null;
        }
        // Function to return the current fake date
        function maybeFakeNowDate() {
            const fakeDate = getFromStorage(FAKE_DATE_STORAGE_KEY);
            if (fakeDate) {
                const fakeDateObject = new OriginalDate(fakeDate);
                const startTimestamp = getTickStartTimestamp();
                if (startTimestamp === null) {
                    return fakeDateObject;
                }
                const elapsed = OriginalDate.now() - startTimestamp;
                return new OriginalDate(fakeDateObject.getTime() + elapsed);
            }
            return new OriginalDate();
        }
        // Fake Date constructor
        const FakeDate = function (...args) {
            if (args.length === 0) {
                return maybeFakeNowDate();
            }
            return new OriginalDate(...args);
        };
        FakeDate.prototype = OriginalDate.prototype;
        FakeDate.prototype.constructor = FakeDate;
        // Override static methods
        FakeDate.now = () => maybeFakeNowDate().getTime();
        FakeDate.parse = OriginalDate.parse;
        FakeDate.UTC = OriginalDate.UTC;
        // Fake Intl.DateTimeFormat constructor
        const FakeIntlDateTimeFormat = function (locales, options) {
            const instance = new OriginalIntlDateTimeFormat(locales, options);
            // Return a proxy that intercepts method calls
            return new Proxy(instance, {
                get(target, prop) {
                    const value = target[prop];
                    // Special handling for format and formatToParts to inject fake date
                    if (prop === 'format' || prop === 'formatToParts') {
                        return function (date) {
                            return target[prop](date ?? maybeFakeNowDate());
                        };
                    }
                    // For other methods, bind them to the target if they're functions
                    if (typeof value === 'function') {
                        return value.bind(target);
                    }
                    return value;
                },
            });
        };
        FakeIntlDateTimeFormat.prototype = OriginalIntlDateTimeFormat.prototype;
        // Copy static methods from original Intl.DateTimeFormat
        Object.getOwnPropertyNames(OriginalIntlDateTimeFormat).forEach((key) => {
            if (typeof OriginalIntlDateTimeFormat[key] === 'function') {
                FakeIntlDateTimeFormat[key] = OriginalIntlDateTimeFormat[key].bind(OriginalIntlDateTimeFormat);
            }
        });
        // Override the global Date and Intl.DateTimeFormat
        window.Date = FakeDate;
        window.Intl.DateTimeFormat = FakeIntlDateTimeFormat;
    }
};
